$("<span id='sleep' class='id-link'></span>").insertBefore("#shopify-section-template--21910688334121__image_with_text_d4KgR9");

$(document).ready(function () {
    $('.footer-item--text .rte p:first').replaceWith('<a href="mailto:support@vitalneuro.com">support@vitalneuro.com</a>');
});

$('<a href="https://vitalneuro.com/products/vital-neuro/"></a>').insertAfter('.what-is-vital .rich-text-blocks .rich-text__content');
$('.testimonails-silder-list').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,

});

$('.vital-team-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,

});

const buttonAddToCart = document.querySelector('#product_page_addtocart');
buttonAddToCart?.addEventListener('click', e => {
    buttonAddToCart.classList.add('no__pseudos');
    const originalContent = buttonAddToCart.innerHTML;
    const spinner = document.createElement('div');
    spinner.classList.add('spinner');
    buttonAddToCart.innerHTML = '';
    buttonAddToCart.appendChild(spinner);
    setTimeout(() => {
        buttonAddToCart.innerHTML = originalContent;
    }, 3000);
})

const buttonAddToCartFloat = document.querySelector('#addtocart__float');
buttonAddToCartFloat?.addEventListener('click', e => {
    buttonAddToCartFloat.classList.add('no__pseudos');
    const originalContent = buttonAddToCartFloat.innerHTML;
    const spinner = document.createElement('div');
    spinner.classList.add('spinner');
    buttonAddToCartFloat.innerHTML = '';
    buttonAddToCartFloat.appendChild(spinner);
    setTimeout(() => {
        buttonAddToCartFloat.innerHTML = originalContent;
    }, 3000);
})



// const image = document.querySelector("#element");

// image.addEventListener("mousemove", event => {
//   const { top, bottom, left, right } = event.target.getBoundingClientRect();

//   const middleX = (right - left) / 4;
//   const middleY = (bottom - top) / 4;

//   const clientX = event.clientX;
//   const clientY = event.clientY;

//   const offsetX = (clientX - middleX) / middleX;
//   const offsetY = (middleY - clientY) / middleY;

//   event.target.style.transform = `perspective(1000px) rotateY(${offsetX *
//     5}deg) rotateX(${offsetY * 5}deg) scale3d(1, 1, 1)`;
// });

// let card = document.querySelector("#element");


// window.addEventListener("scroll", () => {
//   var top = window.pageYOffset / 5;
//   card.style.transform = 'rotate3d(0, 0.5, 0, ' + top + 'deg)';
// });



var modal = document.querySelector(".modal");
var trigger = document.querySelector(".trigger");
var closeButton = document.querySelector(".close-button");

function toggleModal() {
    modal.classList.toggle("show-modal");
}

function windowOnClick(event) {
    if (event.target === modal) {
        toggleModal();
    }
}

trigger?.addEventListener("click", toggleModal);
closeButton?.addEventListener("click", toggleModal);
window.addEventListener("click", windowOnClick);

$('.tab-menu li a').on('click', function () {
    var target = $(this).attr('data-rel');
    $('.tab-menu li a').removeClass('active');
    $(this).addClass('active');
    $("#" + target).fadeIn('slow').siblings(".tab-box").hide();
    return false;
});


$('.video-testimonials-list').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 1120,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
if ($(window).width() < 767)  {
  $("li.show-list").hide();
$("button#readmore").click(function(){
    $("li.show-list").slideToggle(500);
    if ($('button#readmore').text() == "Read more") {
      $(this).text("Read less");
      $(this).addClass('readless');
    } else {
      $(this).text("Read more")
      $(this).removeClass('readless');
    }
  });
$(".testimonials-list .custom-video-modal video").prop('muted', true);
}
